import { Suspense, useContext, useEffect } from "react";
import SignIn from "../../pages/auth/SignIn";
import OrderPage from "../../pages/orders/OrderPage";
import CreateOrder from "../../pages/orders/CreateOrder";
import { Routes as Router, Route } from "react-router-dom";

import { Navigate, useLocation, useNavigate } from "react-router";
import AuthContext from "../../context/auth";
import { useUserRoutes } from "../../hooks/user/user";
import Loader from "../../assets/components/loader/Loader";
import TopBarIcons from "../../components/topbar/TopBarIcons";
import MainLayout from "../../assets/layout/MainLayout";
import { TopBar as topBarType } from "../../types/menuTypes";
import TopBar from "../../components/topbar/TopBar";
import { UserMenu } from "../../types/authTypes";

const Routes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUserMenu, userMenu, setCurrentUser } =
    useContext(AuthContext);

  const { routes, authState, retryAuth } = useUserRoutes(user, setUserMenu, setCurrentUser);

  useEffect(() => {
    if (location.pathname === "/signin" || location.pathname === "/") {
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  const topbar = userMenu as unknown as topBarType[];
  const menus = userMenu as UserMenu[];

  if (!user) {
    return (
      <Router>
        <Route path="/" element={<SignIn />} />
        <Route path="*" element={<SignIn />} />
      </Router>
    );
  }

  // User is logged in but menus haven't loaded yet
  if (!userMenu.length) {
    if (authState === "error") {
      // All retries exhausted — auto-recovery is polling every 30 s in the background.
      // Show "reconnecting" state with a manual retry button as well.
      return (
        <Loader
          pageTitle="Opnieuw verbinden..."
          pageText="Verbinding verbroken. Automatisch opnieuw proberen..."
          onRetry={retryAuth}
        />
      );
    }
    // Still in initial retry sequence — Loader escalates its own messages at 8 s / 20 s
    return <Loader pageTitle="Applicatie laden" onRetry={retryAuth} />;
  }

  return (
    <Suspense fallback={<Loader pageTitle="Applicatie laden" onRetry={retryAuth} />}>
      <MainLayout>
        <TopBar>
          <div className="d-flex w-100 topbar-items">
            {<TopBarIcons topbar={topbar} />}
          </div>
        </TopBar>
        <div className="px-2">
          <Router>
            <Route
              path="/"
              element={
                <Navigate
                  replace
                  to={
                    menus.filter((item) => item.type !== "topbar")[0]?.to ??
                    "/orders"
                  }
                />
              }
            />
            {routes}
            <Route path="/orders/nieuw" element={<CreateOrder />} />
            <Route path="/orders/:id" element={<OrderPage />} />
          </Router>
        </div>
      </MainLayout>
    </Suspense>
  );
};

export default Routes;
